import { render, staticRenderFns } from "./login-sop.vue?vue&type=template&id=45e74655&scoped=true&"
import script from "./login-sop.vue?vue&type=script&lang=js&"
export * from "./login-sop.vue?vue&type=script&lang=js&"
import style0 from "./login-sop.vue?vue&type=style&index=0&id=45e74655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e74655",
  null
  
)

export default component.exports